import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { TenantProvider, useTenant } from '../context/TenantContext';
import TenantShell from '../layouts/shells/TenantShell';

/**
 * Inner guard — runs inside TenantProvider so it can read the context.
 * Renders the shell + outlet, or redirects when access is denied.
 */
const TenantGuard = () => {
  const { canView, loading, error } = useTenant();

  if (loading) {
    return (
      <div className="panel-loading" aria-busy="true">
        <span>Loading community…</span>
      </div>
    );
  }

  if (!canView) {
    return <Navigate to="/dashboard" replace />;
  }

  if (error) {
    return (
      <div style={{ padding: 32, color: '#ef4444', fontFamily: 'monospace' }}>
        {error}
      </div>
    );
  }

  return <TenantShell />;
};

/**
 * TenantRouter — outer auth guard + TenantProvider wrapper.
 *
 * Placed as the element on the /t/:tenantSlug route.
 * Only platform staff + active community members can pass TenantGuard.
 */
const TenantRouter = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="panel-loading" aria-busy="true">
        <span>Loading…</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <TenantProvider>
      <TenantGuard />
    </TenantProvider>
  );
};

export default TenantRouter;
